(function () {
  "use strict";
  var L = window.Lagom;
  if (!L || !L.q || L.cloudsLoaded) return;
  L.cloudsLoaded = !0;
  var q = L.q,
    qa = L.qa,
    MOTION = L.MOTION,
    IMG = L.assetBase || "",
    motionOff = L.motionOff;
  function bootClouds() {
    var wraps = L.off && L.off.clouds ? [] : qa("[data-clouds]");
    function onLoad(fn) {
      document.readyState === "complete"
        ? window.setTimeout(fn, 0)
        : window.addEventListener("load", fn);
    }
    if (!wraps.length) return;
    var SRCSET =
        L.cloud && L.cloud.srcset
          ? L.cloud.srcset
          : "" +
            IMG +
            "sky-cloud-mid-1-400-c.webp 400w, " +
            IMG +
            "sky-cloud-mid-1-540-c.webp 540w, " +
            IMG +
            "sky-cloud-mid-1-800-c.webp 800w",
      SIZES = "(max-width: 767px) 135px, 520px",
      AR = 697 / 1255,
      LAYERS = [
        {
          k: "back",
          n: [3, 1],
          w: [18, 27],
          o: [0.85, 0.95],
          v: [6, 9],
          par: 0.1,
          y: [0.1, 0.3],
        },
        {
          k: "mid",
          n: [2, 1],
          w: [32, 42],
          o: [1, 1],
          v: [12, 16],
          par: 0.25,
          y: [0.32, 0.58],
        },
        {
          k: "front",
          n: [1, 0],
          w: [60, 78],
          o: [1, 1],
          v: [20, 26],
          par: 0.45,
          y: [0.74, 0.84],
        },
      ],
      SECTION = {
        final: { y: { back: [0.08, 0.2], mid: [0.25, 0.45] } },
        stats: {
          n: { back: [1, 0], mid: [1, 1], front: [0, 0] },
          y: { back: [0.05, 0.2], mid: [0.55, 0.7] },
        },
        timeline: {
          n: { back: [1, 1], mid: [1, 0], front: [0, 0] },
          y: { back: [0.1, 0.25], mid: [0.6, 0.75] },
        },
        kids: {
          n: { back: [1, 0], mid: [1, 1], front: [0, 0] },
          y: { back: [0.6, 0.75], mid: [0.05, 0.2] },
        },
        social: {
          n: { back: [1, 1], mid: [1, 0], front: [0, 0] },
          y: { back: [0.05, 0.2], mid: [0.55, 0.7] },
        },
        compare: {
          n: { back: [1, 0], mid: [1, 1], front: [0, 0] },
          y: { back: [0.45, 0.6], mid: [0.08, 0.25] },
        },
        faq: {
          n: { back: [1, 1], mid: [1, 0], front: [0, 0] },
          y: { back: [0.1, 0.25], mid: [0.55, 0.7] },
        },
        footer: {
          n: { back: [2, 1], mid: [0, 0], front: [0, 0] },
          y: { back: [0, 0.05] },
        },
        hero: { lane: 0.14 },
      },
      CFG = { speed: 0.2, parallax: 1.5, breathe: !0, count: 4 },
      LAYOUT = L.cloudLayout || {},
      phone = window.matchMedia("(max-width: 767px)"),
      header = q(".header__inner"),
      PARALLAX = !!(
        window.CSS &&
        CSS.supports &&
        CSS.supports("animation-timeline: scroll()")
      );
    function rng(seed) {
      return function () {
        seed = (seed + 1831565813) | 0;
        var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
        return (
          (t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t),
          ((t ^ (t >>> 14)) >>> 0) / 4294967296
        );
      };
    }
    function hash(s) {
      for (var h = 2166136261, i = 0; i < s.length; i++)
        h = Math.imul(h ^ s.charCodeAt(i), 16777619);
      return h;
    }
    function lerp(a, b, t) {
      return a + (b - a) * t;
    }
    function clamp(v) {
      return v < 0 ? 0 : v > 1 ? 1 : v;
    }
    var sections = wraps.map(function (wrap) {
        var name = wrap.getAttribute("data-clouds"),
          root = wrap.closest("section") || wrap.parentNode;
        return {
          wrap: wrap,
          name: name,
          root: root,
          cfg: SECTION[name] || {},
          clouds: [],
          texts: qa("[data-sky-text]", root),
          hero: name === "hero",
          W: 0,
          H: 0,
          frozen: !1,
          css: "",
          range: "",
        };
      }),
      sheet = document.createElement("style");
    (sheet.setAttribute("data-cloud-keyframes", ""),
      document.head.appendChild(sheet));
    var mode = null,
      loaded = !1,
      waiting = [],
      started = !1;
    function build() {
      var m = phone.matches ? 1 : 0;
      m !== mode &&
        ((mode = m),
        sections.forEach(function (s) {
          ((s.wrap.textContent = ""), (s.clouds = []));
          var r = rng(hash(s.name + m)),
            idx = 0,
            lastFlip = 1,
            man = LAYOUT[s.name] && LAYOUT[s.name][m ? "p" : "d"];
          if (man) {
            man.forEach(function (d) {
              addManual(s, d, m);
            });
            return;
          }
          LAYERS.forEach(function (Lr, li) {
            for (
              var n = ((s.cfg.n && s.cfg.n[Lr.k]) || Lr.n)[m],
                band = (s.cfg.y && s.cfg.y[Lr.k]) || Lr.y,
                i = 0;
              i < n;
              i++
            ) {
              var eager = s.hero && idx === 0,
                el = cloudImg(eager);
              ((el.className = "sky-cloud sky-cloud--" + Lr.k),
                el.setAttribute("aria-hidden", "true"));
              var flip = idx === 0 ? (r() < 0.5 ? -1 : 1) : -lastFlip;
              lastFlip = flip;
              var c = {
                el: el,
                L: Lr,
                li: li,
                idx: idx,
                w:
                  lerp(Lr.w[0], Lr.w[1], r()) *
                  (s.hero && m === 0 && (idx === 1 || idx === 3) ? 0.72 : 1),
                op:
                  lerp(Lr.o[0], Lr.o[1], r()) *
                  (s.hero && m === 0 && (idx === 1 || idx === 3) ? 0.85 : 1),
                v: lerp(Lr.v[0], Lr.v[1], r()),
                y0: lerp(band[0], band[1], r()),
                x0: (i + 0.15 + r() * 0.7) / Math.max(1, n) + li * 0.21,
                rot: (r() * 2 - 1) * 3,
                flip: flip,
                side: s.hero
                  ? m === 0 && (idx === 1 || idx === 3)
                    ? -1
                    : 1
                  : idx % 2
                    ? 1
                    : -1,
                p1: 8e3 + r() * 6e3,
                p2: 9500 + r() * 7e3,
                ph1: r() * 6.28,
                ph2: r() * 6.28,
              };
              (idx >= CFG.count && ((el.style.display = "none"), (c.off = !0)),
                s.clouds.push(c),
                mount(s, c),
                (idx += 1));
            }
          });
        }),
        measure());
    }
    function addManual(s, d, m) {
      var Lr = d.w < 30 ? LAYERS[0] : d.w < 55 ? LAYERS[1] : LAYERS[2],
        idx = s.clouds.length,
        r = rng(hash(s.name + m + idx)),
        el = cloudImg(!1);
      ((el.className = "sky-cloud sky-cloud--" + Lr.k),
        el.setAttribute("aria-hidden", "true"));
      var c = {
        el: el,
        L: Lr,
        li: LAYERS.indexOf(Lr),
        idx: idx,
        man: !0,
        d: d,
        w: d.w,
        op: d.o == null ? 1 : d.o,
        v: lerp(Lr.v[0], Lr.v[1], r()),
        rot: 0,
        flip: d.f || 1,
        p1: 8e3 + r() * 6e3,
        p2: 9500 + r() * 7e3,
        ph1: r() * 6.28,
        ph2: r() * 6.28,
      };
      return (s.clouds.push(c), mount(s, c), c);
    }
    function mount(s, c) {
      var par = document.createElement("div");
      ((par.className = "sky-cloud-par sky-cloud-par--" + c.L.k),
        par.appendChild(c.el),
        (c.par = par),
        s.wrap.appendChild(par));
    }
    function setSrc(img) {
      ((img.loading = "eager"),
        img.setAttribute("fetchpriority", "low"),
        (img.sizes = SIZES),
        (img.srcset = SRCSET),
        (img.src =
          L.cloud && L.cloud.src
            ? L.cloud.src
            : "" + IMG + "sky-cloud-mid-1-800-c.webp"),
        L.cloud &&
          L.cloud.src &&
          !L.cloud.builtin &&
          img.classList.add("sky-cloud--custom"),
        img.decode && img.decode().catch(function () {}));
    }
    function cloudImg(eager) {
      var img = document.createElement("img");
      return (
        (img.alt = ""),
        (img.decoding = "async"),
        (img.width = 1255),
        (img.height = 697),
        img.addEventListener("load", function () {
          img.classList.add("is-ready");
        }),
        eager || (img.loading = "lazy"),
        loaded ? setSrc(img) : waiting.push(img),
        img
      );
    }
    onLoad(function () {
      window.setTimeout(
        function () {
          ((loaded = !0), waiting.splice(0).forEach(setSrc), start());
        },
        document.readyState === "complete" ? 0 : 500,
      );
    });
    var VH = window.innerHeight,
      lastCss = "";
    function measure(only) {
      var vw = window.innerWidth / 100,
        dpr = window.devicePixelRatio || 1,
        sy = window.pageYOffset;
      VH = window.innerHeight;
      var hr = header ? header.getBoundingClientRect() : null,
        todo = sections.filter(function (s) {
          return !s.frozen && (!only || only.indexOf(s) >= 0);
        }),
        reads = todo.map(function (s) {
          var wr = s.wrap.getBoundingClientRect(),
            zones = s.texts
              .map(function (el) {
                var r = el.getBoundingClientRect();
                return [
                  r.left - wr.left - 24,
                  r.top - wr.top - 24,
                  r.right - wr.left + 24,
                  r.bottom - wr.top + 24,
                  0.55,
                ];
              })
              .filter(function (z) {
                return z[2] - z[0] > 48;
              });
          return (
            hr &&
              zones.push([
                hr.left - wr.left,
                hr.top - wr.top - 8,
                hr.right - wr.left,
                hr.bottom - wr.top + 8,
                0.35,
              ]),
            {
              W: s.wrap.clientWidth,
              H: s.wrap.clientHeight,
              top: wr.top + sy,
              zones: zones,
            }
          );
        });
      todo.forEach(function (s, i) {
        var d = reads[i];
        ((s.W = d.W), (s.H = d.H), (s.zones = d.zones));
        var css = "";
        (s.clouds.forEach(function (c) {
          c.off ||
            ((c.cw = Math.round(c.w * vw)),
            (c.ch = Math.round(c.cw * AR)),
            (c.lw = Math.min(c.cw, Math.round(1255 / dpr))),
            (c.lh = Math.round(c.lw * AR)),
            (c.k = c.cw / c.lw),
            (css += place(s, c)));
        }),
          (s.css = css));
        var range =
          Math.round(d.top - VH) + "px " + Math.round(d.top + d.H) + "px";
        range !== s.range &&
          (s.wrap.style.setProperty("--sky-r0", Math.round(d.top - VH) + "px"),
          s.wrap.style.setProperty("--sky-r1", Math.round(d.top + d.H) + "px"),
          (s.range = range));
      });
      var all = sections
        .map(function (s) {
          return s.css;
        })
        .join("");
      all !== lastCss && ((sheet.textContent = all), (lastCss = all));
    }
    function place(s, c) {
      var lo, hi, xc, y;
      if (c.man)
        ((xc = c.d.x * s.W),
          (lo = xc - 0.02 * s.W),
          (hi = xc + 0.02 * s.W),
          (y = c.d.y * s.H));
      else {
        var l0 = -0.6 * c.cw,
          h0 = Math.max(l0, (s.cfg.lane || 0.3) * s.W - 0.85 * c.cw);
        (c.side < 0
          ? ((lo = l0), (hi = h0))
          : ((lo = s.W - c.cw - h0), (hi = s.W - c.cw - l0)),
          (xc = (lo + hi) / 2),
          (y = c.y0 * s.H));
      }
      var op = c.op,
        bw = c.cw,
        bh = c.ch,
        target = op;
      c.man ||
        s.zones.forEach(function (z) {
          var ix = Math.min(xc + bw, z[2]) - Math.max(xc, z[0]),
            iy = Math.min(y + bh, z[3]) - Math.max(y, z[1]);
          if (ix > 0 && iy > 0) {
            var cover = clamp(
              ((ix * iy) / Math.min(bw * bh, (z[2] - z[0]) * (z[3] - z[1]))) *
                4,
            );
            target = Math.min(target, op - Math.max(0, op - z[4]) * cover);
          }
        });
      var cy = y + bh / 2,
        eTop = clamp(cy / (0.07 * s.H)),
        eBot = clamp((s.H - cy) / (0.09 * s.H));
      ((target *= Math.min(eTop, eBot)),
        (c.base = Math.min(1, Math.max(0, target))));
      var dx = (c.cw - c.lw) / 2,
        dy = (c.ch - c.lh) / 2;
      function tf(x2, sc2) {
        var ks = sc2 * c.k;
        return (
          "translate3d(" +
          (x2 + dx).toFixed(1) +
          "px," +
          (y + dy).toFixed(1) +
          "px,0) rotate(" +
          c.rot.toFixed(2) +
          "deg) scale(" +
          (ks * c.flip).toFixed(4) +
          "," +
          ks.toFixed(4) +
          ")"
        );
      }
      for (
        var drift = s.cfg.drift || 1,
          P = 1885 / (c.v * drift),
          half = P / 2,
          N = 12,
          kf = [],
          k = 0;
        k <= N;
        k++
      ) {
        var u = k / N,
          t = u * half,
          ang = -Math.PI / 2 + Math.PI * u,
          swing = 0.5 + 0.5 * Math.sin(ang),
          x = lo + (hi - lo) * swing,
          sc = 1,
          o = c.base;
        (CFG.breathe &&
          ((sc +=
            0.03 * Math.sin((2 * Math.PI * t * 1e3) / (31.4 * c.p1) + c.ph1)),
          (o = Math.min(
            1,
            Math.max(
              0,
              c.base +
                0.06 *
                  Math.sin((2 * Math.PI * t * 1e3) / (31.4 * c.p2) + c.ph2),
            ),
          ))),
          kf.push(
            (u * 100).toFixed(2) +
              "%{transform:" +
              tf(x, sc) +
              ";opacity:" +
              o.toFixed(3) +
              "}",
          ));
      }
      var name = "lc-" + s.name + "-" + c.idx + "-" + mode,
        delay = -(c.ph1 / 6.2832) * P,
        st = {
          width: c.lw + "px",
          transform: tf(xc, 1),
          op: c.base.toFixed(3),
          anim: motionOff()
            ? "none"
            : name +
              " " +
              half.toFixed(1) +
              "s linear infinite alternate " +
              delay.toFixed(1) +
              "s",
        };
      ((!c.st || c.st.width !== st.width) && (c.el.style.width = st.width),
        (!c.st || c.st.transform !== st.transform) &&
          (c.el.style.transform = st.transform),
        (!c.st || c.st.op !== st.op) &&
          c.el.style.setProperty("--cloud-opacity", st.op),
        (!c.st || c.st.anim !== st.anim) && (c.el.style.animation = st.anim),
        (c.st = st),
        c.inSet ||
          (c.par.style.setProperty("--cloud-in-delay", c.li * 120 + "ms"),
          c.par.style.setProperty(
            "--cloud-in-dx",
            (c.side < 0 ? -40 : 40) + "px",
          ),
          (c.inSet = !0)));
      var parPx = (0.75 * c.L.par * CFG.parallax * s.H).toFixed(1) + "px";
      return (
        c.parPx !== parPx &&
          (c.par.style.setProperty("--cloud-par", parPx), (c.parPx = parPx)),
        "@keyframes " + name + "{" + kf.join("") + "}"
      );
    }
    function start() {
      started ||
        ((started = !0),
        sections.forEach(function (s) {
          s.hero && s.wrap.classList.add("is-in");
        }));
    }
    (build(), loaded && start());
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var s = sections.filter(function (x) {
            return x.wrap === e.target;
          })[0];
          s &&
            !motionOff() &&
            s.wrap.classList.toggle("is-idle", !e.isIntersecting);
        });
      },
      { rootMargin: "200px 0px" },
    );
    (sections.forEach(function (s) {
      io.observe(s.wrap);
    }),
      MOTION.addEventListener("change", function () {
        measure();
      }));
    var lastW = window.innerWidth;
    if (
      (window.addEventListener("resize", function () {
        window.innerWidth !== lastW &&
          ((lastW = window.innerWidth),
          sections.forEach(function (s) {
            s.frozen = !1;
          }),
          build(),
          measure());
      }),
      onLoad(function () {
        measure();
      }),
      document.fonts &&
        document.fonts.ready &&
        document.fonts.ready.then(function () {
          measure();
        }),
      document.addEventListener(
        "lagom:tab",
        function (e) {
          sections.forEach(function (s) {
            s.root.contains(e.target) && (s.frozen = !0);
          });
        },
        !0,
      ),
      window.ResizeObserver)
    ) {
      var roPending = [],
        roRaf = 0,
        ro = new ResizeObserver(function (entries) {
          (entries.forEach(function (en) {
            var s = sections.filter(function (x) {
              return x.wrap === en.target;
            })[0];
            s &&
              !s.frozen &&
              Math.abs(s.wrap.clientHeight - s.H) > 1 &&
              roPending.indexOf(s) < 0 &&
              roPending.push(s);
          }),
            roPending.length &&
              !roRaf &&
              (roRaf = window.requestAnimationFrame(function () {
                roRaf = 0;
                var list = roPending.splice(0),
                  first = Math.min.apply(
                    null,
                    list.map(function (x) {
                      return sections.indexOf(x);
                    }),
                  );
                measure(
                  sections.filter(function (x, i) {
                    return i >= first;
                  }),
                );
              })));
        });
      sections.forEach(function (s) {
        ro.observe(s.wrap);
      });
    }
    document.documentElement.classList.toggle("has-cloud-parallax", PARALLAX);
  }
  (function () {
    var done = !1;
    function go() {
      done || ((done = !0), bootClouds());
    }
    var idle = window.requestIdleCallback
      ? function (f) {
          window.requestIdleCallback(f, { timeout: 1500 });
        }
      : function (f) {
          window.setTimeout(f, 1);
        };
    document.readyState === "complete"
      ? idle(go)
      : (window.addEventListener("load", function () {
          idle(go);
        }),
        window.setTimeout(go, 2500));
  })();
})();

